function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _templateObject;
var _excluded = ["className", "ellipsis", "initialSelectedIndex", "keyset", "look", "onSelected", "optionProps", "options", "selectedIndex", "virtualized", "virtualizedProps"],
  _excluded2 = ["look"];
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import classnames from 'classnames';
import React, { forwardRef, useRef, useEffect, useContext } from 'react';
import { Virtuoso } from 'react-virtuoso';
import styled, { ThemeContext, ThemeProvider } from 'styled-components';
import "../../../../enums/accordion.js";
import "../../../../enums/alert.js";
import "../../../../enums/avatar.js";
import "../../../../enums/breakpoints.js";
import "../../../../enums/button.js";
import "../../../../enums/code-editor.js";
import "../../../../enums/colors.js";
import "../../../../enums/combobox.js";
import "../../../../enums/date.js";
import "../../../../enums/drag-and-drop.js";
import "../../../../enums/dialog.js";
import "../../../../enums/divider.js";
import "../../../../enums/dropdown.js";
import "../../../../enums/fieldset.js";
import "../../../../enums/font-icon.js";
import "../../../../enums/fonts.js";
import "../../../../enums/headings.js";
import "../../../../enums/input.js";
import "../../../../enums/keys.js";
import "../../../../enums/list.js";
import { ListboxLooks } from "../../../../enums/listbox.js";
import "../../../../enums/loader.js";
import "../../../../enums/margin.js";
import "../../../../enums/option.js";
import "../../../../enums/pill.js";
import "../../../../enums/placements.js";
import "../../../../enums/popout.js";
import "../../../../enums/privacy.js";
import "../../../../enums/radio-group.js";
import "../../../../enums/status.js";
import "../../../../enums/switch.js";
import "../../../../enums/table.js";
import "../../../../enums/tooltip.js";
import "../../../../enums/transitions.js";
import "../../../../enums/widths.js";
import "../../../../utilities/color.js";
import 'date-fns';
import "../../../../utilities/locale.js";
import { mergeRefs } from "../../../../utilities/refs.js";
import { usePreventKeyboardScrolling } from "../../../../hooks/use-prevent-keyboard-scrolling.js";
import "../../../../styles/styled-components/alert.js";
import "../../../../styles/styled-components/animations.js";
import { boxShadowListboxes } from "../../../../styles/styled-components/box-shadow.js";
import "../../../../styles/styled-components/button.js";
import "../../../../themes/alert.js";
import "../../../../themes/button.js";
import "../../../../themes/checkbox.js";
import "../../../../themes/divider.js";
import "../../../../themes/dropdown.js";
import "../../../../themes/fieldset.js";
import "../../../../themes/input.js";
import "../../../../themes/list.js";
import "../../../../themes/listbox.js";
import "../../../../themes/loader.js";
import "../../../../themes/option.js";
import "../../../../themes/popout.js";
import "../../../../themes/switch.js";
import { lightTheme } from "../../../../themes/themes.js";
import "../../../../themes/tooltip.js";
import "../../../../styles/styled-components/font-face.js";
import "../../../../styles/styled-components/global.js";
import "../../../../styles/styled-components/input.js";
import { baseListStyle, getListVirtualizedCss } from "../../../../styles/styled-components/list.js";
import { getListboxTheme } from "../../../../styles/styled-components/listbox.js";
import "../../../../styles/styled-components/listitem.js";
import "../../../../styles/styled-components/media-queries.js";
import "../../../../styles/styled-components/reset.js";
import "../../../../styles/styled-components/outline.js";
import "../../../../styles/styled-components/popout.js";
import "../../../../styles/styled-components/screen-reader.js";
import "../../../../styles/styled-components/switch.js";
import "../../../../styles/styled-components/tooltip.js";
import { StandardOption } from "../../option/standard-option/standard-option.js";
import { BaseListbox } from "../base-listbox/base-listbox.js";
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
var borderWidth = 1;
var height = 250;
var padding = 10;
var BaseStandardListbox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _classnames;
  var className = props.className,
    ellipsis = props.ellipsis,
    initialSelectedIndex = props.initialSelectedIndex,
    keyset = props.keyset,
    look = props.look,
    onSelected = props.onSelected,
    optionProps = props.optionProps,
    options = props.options,
    selectedIndex = props.selectedIndex,
    virtualized = props.virtualized,
    virtualizedProps = props.virtualizedProps,
    otherProps = _objectWithoutProperties(props, _excluded);
  var isVirtualized = virtualized && options.length > 10;
  var listboxRef = useRef(null);
  var virtuosoRef = useRef(null);
  useEffect(function () {
    if (virtuosoRef.current && selectedIndex !== undefined) {
      /**
      * If you change `scrollToIndex` `behavior`, also change `scroll` `behavior` in `StandardOption`
      */
      virtuosoRef.current.scrollToIndex({
        index: selectedIndex,
        align: 'center',
        behavior: 'auto'
      });
    }
  }, [selectedIndex]);
  usePreventKeyboardScrolling(keyset);
  return /*#__PURE__*/React.createElement(BaseListbox, _extends({}, otherProps, {
    className: classnames((_classnames = {
      'bf-listbox__standard': true
    }, _defineProperty(_classnames, "bf-listbox__standard--look-".concat(look), look), _defineProperty(_classnames, 'bf-listbox__standard--virtualized', isVirtualized), _defineProperty(_classnames, "".concat(className), !!className), _classnames)),
    ref: mergeRefs([listboxRef, ref])
  }), options.length === 0 ? null : isVirtualized ? /*#__PURE__*/React.createElement(Virtuoso, _extends({}, virtualizedProps, {
    className: classnames(_defineProperty({
      'bf-listbox__virtualized': true
    }, "".concat(virtualizedProps === null || virtualizedProps === void 0 ? void 0 : virtualizedProps.className), !!(virtualizedProps !== null && virtualizedProps !== void 0 && virtualizedProps.className))),
    initialTopMostItemIndex: initialSelectedIndex !== null && initialSelectedIndex !== void 0 ? initialSelectedIndex : 0,
    itemContent: function itemContent(index) {
      return /*#__PURE__*/React.createElement(StandardOption, _extends({}, optionProps, {
        ellipsis: ellipsis,
        index: index,
        listboxPadding: padding,
        listboxRef: listboxRef,
        onSelected: onSelected,
        option: options[index],
        selectedIndex: selectedIndex
      }));
    },
    ref: virtuosoRef,
    style: {
      height: height - borderWidth * 2
    },
    totalCount: options.length
  })) : options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(StandardOption, _extends({}, optionProps, {
      ellipsis: ellipsis,
      index: index,
      listboxPadding: padding,
      listboxRef: listboxRef,
      key: option.key,
      onSelected: onSelected,
      option: option,
      selectedIndex: selectedIndex
    }));
  }));
});
var Listbox = styled(BaseStandardListbox)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n  ", "\n  ", "\n  ", "\n\n  &.bf-listbox__standard--virtualized {\n    overflow: unset;\n    padding: 0;\n  }\n\n  .bf-listbox__virtualized {\n    > div {\n      padding: ", "px ", "px 0;\n\n      > div > div {\n        &:last-child {\n          padding-bottom: ", "px;\n        }\n      }\n    }\n  }\n"])), baseListStyle, boxShadowListboxes, function (_ref) {
  var look = _ref.look;
  return getListboxTheme({
    look: look
  });
}, getListVirtualizedCss({
  borderWidth: borderWidth,
  height: height,
  padding: padding
}), padding, padding, padding);
/**
 * A `role="listbox"` is used to identify an element that creates a list
 * from which a user may select one or more static items. It must contain one
 * or more `role="option"` elements.
 *
 * This component provides `<select>` functionality with with more flexibility
 * in styling and in rendering content within each `role="option"`
 * (such as including `<img>` elements).
 *
 * The `role="listbox"` can be virtualized (a.k.a windowing) for better performance
 * with many `role="option"` elements by setting `virtualized` to `true`.
 *
 * https://www.w3.org/TR/wai-aria-1.2/#listbox
 *
 * https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Roles/listbox_role
 *
 * @returns React.ForwardRefExoticComponent<StandardListboxProps & React.RefAttributes<HTMLUListElement>>
 */
var StandardListbox = /*#__PURE__*/forwardRef(function (props, ref) {
  var _props$look = props.look,
    look = _props$look === void 0 ? ListboxLooks.Default : _props$look,
    otherProps = _objectWithoutProperties(props, _excluded2);
  var themeContext = useContext(ThemeContext);
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: themeContext || lightTheme
  }, /*#__PURE__*/React.createElement(Listbox, _extends({}, otherProps, {
    look: look,
    ref: ref
  })));
});
export { BaseStandardListbox, StandardListbox };